import React, { useMemo } from 'react';
import './styles/Loader.css';

const EMOJIS = ['😳', '🥳', '😍', '😌', '🥹', '😎', '😵‍💫'];

export const Loader: React.FC = () => {
    const emoji = useMemo(() => EMOJIS[Math.floor(Math.random() * EMOJIS.length)], []);

    return (
      <div className="loader-card" role="status" aria-live="polite">
            <div className="emoji-spinner" aria-hidden="true">{emoji}</div>
            <div className="loader-text">Пожалуйста, подождите...</div>
        </div>
    );
}